import { render, staticRenderFns } from "./SplideWrapper.vue?vue&type=template&id=269acc6a&scoped=true"
import script from "./SplideWrapper.vue?vue&type=script&lang=js"
export * from "./SplideWrapper.vue?vue&type=script&lang=js"
import style0 from "./SplideWrapper.vue?vue&type=style&index=0&id=269acc6a&prod&lang=scss&scoped=true"
import style1 from "./SplideWrapper.vue?vue&type=style&index=1&id=269acc6a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269acc6a",
  null
  
)

export default component.exports